import { render, staticRenderFns } from "./CommsHistoryView.vue?vue&type=template&id=6e2013d0&lang=html"
import script from "./CommsHistoryView.vue?vue&type=script&lang=js"
export * from "./CommsHistoryView.vue?vue&type=script&lang=js"
import style0 from "./CommsHistoryView.vue?vue&type=style&index=0&id=6e2013d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports